import { render, staticRenderFns } from "./TTPDOrderSigningInfo.vue?vue&type=template&id=327dddb4&"
import script from "./TTPDOrderSigningInfo.vue?vue&type=script&lang=js&"
export * from "./TTPDOrderSigningInfo.vue?vue&type=script&lang=js&"
import style0 from "./TTPDOrderSigningInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports